











import hash from 'object-hash';
import { listFactory } from '@/main/pages';
// eslint-disable-next-line no-unused-vars
import { convertToObjects, EditableStatus, Row, Table } from '@/main/utils/table';
import { ENTITY } from '@/main/store/listEditTypes';
import { router } from '@/main/router';

import DmsEditableTable from '#components/dms/layout/EditableTable.vue';
import Save from '#components/dms/button/Save.vue';

import { NAME } from './constants';
import { store } from './store/list';
import { apiProvider } from './api';

export default listFactory(NAME, store).extend({
	components: {
		DmsEditableTable,
		'dms-save': Save,
	},
	data() {
		return {
			schemaSettings: {
				isEditable: true,
			},
		};
	},
	computed: {
		isModified(): boolean {
			return this.tableHash !== hash(this.table.rows);
		},
		saveDisabled(): boolean {
			return this.loading;
		},
	},
	methods: {

		createRow() {
			(this.$refs.editableTable as any).createRow();
		},

		async handleSave() {
			try {
				this.startLoading();
				await apiProvider.saveTable(this.VozidloId!, convertToObjects(this.table));
			} finally {
				this.tableHash = hash(this.table.rows);
				this.endLoading();
				await this.$store.dispatch(`${this.props.previousStoreUri}/${ENTITY}`, { id: this.props.previousEntityId });
				router.back();
			}
		},
	},
});
